import {
  AppBar,
  Box,
  Button,
  Card,
  DialogContentText,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Grid,
  Paper,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import { TabPanel } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenSelectWrap from '../../../../global_components/KenSelect';
import RoomAvailablity from './RoomAvailablity';
import SeatingArrangement from './SeatingArrangement';
import MainSeatingPlan from './NewSeatingPlan/index';
import studentJson from './Student.json';

import {
  getSeatingArrangementData,
  getRoomsAvailable,
  postSeatingPlan,
} from '../../../../Utils/apiServices';
import moment from 'moment';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenLoader from '../../../../Components/KenLoader/index';
import KenSnackbar from '../../../../Components/KenSnackbar/index';
import history from '../../../../Utils/history';
import { useSnackbar } from 'notistack';

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  // {
  //   head: 'Exam',
  //   url: routes.ExamSetup,
  // },
  {
    head: 'Seating Plan',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    borderRadius: '8px',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    // textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  typoTitle: {
    top: '271px',
    fontFamily: "'Lato'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '19px',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
    opacity: '0.5',
  },
  typoDescription: {
    position: 'absolute',
    marginTop: '3px',
    fontFamily: "'Lato', sans-serif",
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    color: '#222222',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  card: {
    marginTop: '30px',
    padding: '20px',
    background: '#FEFEFE',
    borderRadius: '8px',
  },
  addButtonBack: {
    marginRight: '10px',
  },
}));

function TabPanels(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: '10px' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const SeatingPlanArrangement = (props) => {
  const location = useLocation();
  const qqqqqqq = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();
  const [currentSeatingPlanData, setCurrentSeatingPlanData] = useState();
  const [eligibleStudentList, setEligibleStudentList] = useState();

  const [roomChoosen, setRoomChoosen] = useState([]);
  let id = currentSeatingPlanData?.totalEligibleStudents;
  let examId = currentSeatingPlanData ? currentSeatingPlanData?.id : qqqqqqq.id;
  const [facilityData, setFacilityData] = useState();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [array3D, setArray3D] = useState([]);
  const [selectValueSpace, setSelectValueSpace] = useState('0');
  // Tab Panel states
  const [value, setValue] = useState(0);
  const [roomData, setRoomData] = useState();
  const [edit, setEdit] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  useEffect(() => {
    setLoading(true);
    getRoomsAvailable(location?.state?.data?.allData?.Id)
      .then((res) => {
        const roomData = [];
        const choosenData = [];
        res?.data?.facilities?.map((el) => {
          if (el?.chosen === false) {
            roomData.push(el);
          } else {
            choosenData.push(el);
          }
        });
        setRoomData({ availableData: [...roomData], ...res?.data });
        setRoomChoosen(choosenData);
        choosenData.length > 0 &&
          setSelectValueSpace(
            choosenData[0]?.intercandidateSpacing.toString() || '0'
          );
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   if (location?.state?.data?.Publish === false) {
  //     if (location?.state?.type == 'Create') {
  //       setEdit(true);
  //     } else if (location?.state?.type == 'Edit') {
  //       setEdit(true);
  //     } else if (location?.state?.type == 'View') {
  //       setEdit(true);
  //     }
  //   }
  // }, [location?.state]);

  useEffect(() => {
    getSeatingArrangementData(location?.state?.data?.allData?.Id).then(
      (res) => {
        console.log(res);
        if (res?.success) {
          setEligibleStudentList(res?.data?.examConnections);
        }
      }
    );
  }, []);

  const handleRoomDeletion = (rooms) => {
    setRoomData({
      ...roomData,
      availableData: [...roomData.availableData, ...rooms],
    });
  };

  const handleRoomAddition = (rooms) => {
    let data = [...roomData?.availableData];
    rooms.forEach((el) => {
      data = data?.filter((delRoom) => delRoom?.facilityId !== el?.facilityId);
    });
    setRoomData({ ...roomData, availableData: [...data] });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [roomDropdown, setRoomDropDown] = useState([]);

  useEffect(() => {
    if (roomChoosen?.length > 0) {
      setRoomDropDown(
        roomChoosen?.map((ele) => {
          return {
            label: `Room ${ele.facilityName}`,
            value: ele.facilityId,
            ...ele,
          };
        })
      );
    }
  }, [roomChoosen]);

  // Eligible for seating arrangement
  const [eligible, setEligible] = useState(false);
  const [numStudents, setNumStudents] = useState(0);
  // selectOptionsCourse.push()
  let seatWidth = '100%';
  // dialog box

  console.log('location', location.state);

  const handleSave = () => {
    const data = JSON.parse(localStorage.getItem('userDetails'));
    if (roomChoosen.some((el) => el?.noOfInvigilators?.length > 1)) {
      return enqueueSnackbar('Please add a single digit for invigilator', {
        variant: 'error',
      });
    } else if (roomChoosen.some((el) => Number(el.noOfInvigilators) == 0)) {
      return enqueueSnackbar("Invigiltor can't be zero", {
        variant: 'error',
      });
    } else if (roomChoosen.some((el) => el.noOfInvigilators === null)) {
      return enqueueSnackbar('Please input invigilator for all rooms', {
        variant: 'error',
      });
    } else {
      const faciltyBooking = roomChoosen.map((el) => {
        return {
          facilityBookingRecordId: el?.facilityBookingRecordId,
          bookedStartDateTime: `${location?.state?.data?.allData?.Exam_Date__c}T${location?.state?.data?.allData?.Start_Time__c}`,
          bookedEndDateTime: `${location?.state?.data?.allData?.Exam_Date__c}T${location?.state?.data?.allData?.End_Time__c}`,
          examId: location?.state?.data?.allData?.Id,
          facilityId: el?.facilityId,
          bookedByContactId: data?.alumniId,
          intercandidateSpacing: Number(selectValueSpace),
          bookedCapacity: 0,
          noOfInvigilators: Number(el?.noOfInvigilators),
        };
      });
      const examConnections = [];
      // const bookedCapacity = [];
      array3D.flat(2).forEach((el) => {
        if (el.studentRecordId !== undefined) {
          examConnections.push({
            examConnectionRecordId: el?.examConnectionRecordId,
            studentRecordId: el?.studentRecordId,
            seatNumber: el?.seatNumber,
            rowNumber: el?.rowNumber,
            facilityId: el?.facilityId,
            columnNumber: el?.columnNumber,
          });
          console.log(
            faciltyBooking.find((elem) => elem.facilityId === el.facilityId)
          );
          faciltyBooking.find(
            (elem) => elem.facilityId === el.facilityId
          ).bookedCapacity =
            faciltyBooking.find((elem) => elem.facilityId === el.facilityId)
              .bookedCapacity + 1;
        }
      });
      const payload = {
        facilityBookings: [...faciltyBooking],
        examConnections: [...examConnections],
      };
      setLoading(true);
      postSeatingPlan(payload)
        .then((res) => {
          console.log(res);
          setDialog(false);
          setEdit(false);
          enqueueSnackbar('Data has been successfully saved', {
            variant: 'success',
          });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };
  const handleEditClick = () => {
    if (roomData?.eligibelStudents === 0) {
      handleSnackbarOpen('error', `There are no eligible students`);
    } else {
      setEdit(true);
    }
  };

  return (
    <Box>
      {loading && <KenLoader />}
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Exam Setup{' '}
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Dialog
              open={dialog}
              onClose={() => {
                setDialog(false);
              }}
              aria-labelledby="draggable-dialog-title"
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle
                style={{ color: '#193389', fontSize: '24px', fontWeight: 600 }}
                id="draggable-dialog-title"
              ></DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to save the data ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  autoFocus
                  onClick={() => {
                    setDialog(false);
                  }}
                  variant="outlined"
                  color="primary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleSave();
                  }}
                  color="primary"
                  variant="contained"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.goBack()}
              className={classes.addButtonBack}
            >
              Back
            </Button>
            {value === 1 &&
            location?.state?.data?.Publish === false &&
            edit === true ? (
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginRight: '15px',
                  background: '#272727 !important',
                  color: 'white',
                }}
                className={classes.addButton}
                onClick={() => {
                  setDialog(true);
                }}
              >
                Save
              </Button>
            ) : (
              <>
                {edit === false && location?.state?.data?.Publish === false && (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.addButton}
                    onClick={handleEditClick}
                  >
                    {location?.state?.data?.SeatPlan == 'Not Created'
                      ? 'Create'
                      : 'Edit'}
                  </Button>
                )}
              </>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      <div className={classes.card}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4} sm={6}>
            <Grid container>
              <Grid item xs={5}>
                <div className={classes.typoTitle}>Program :</div>
              </Grid>
              <Grid item xs={7}>
                <div className={classes.typoDescription}>
                  {location?.state?.program}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Grid container>
              <Grid item xs={5}>
                <div className={classes.typoTitle}>Batch :</div>
              </Grid>
              <Grid item xs={7}>
                <div className={classes.typoDescription}>
                  {location?.state?.batch}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Grid container>
              <Grid item xs={5}>
                <div className={classes.typoTitle}>Term :</div>
              </Grid>
              <Grid item xs={7}>
                <div className={classes.typoDescription}>
                  {location?.state?.term}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Grid container>
              <Grid item xs={5}>
                <div className={classes.typoTitle}>Course :</div>
              </Grid>
              <Grid item xs={7}>
                <div className={classes.typoDescription}>
                  {location?.state?.data?.Course}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Grid container>
              <Grid item xs={5}>
                <div className={classes.typoTitle}>Exam :</div>
              </Grid>
              <Grid item xs={7}>
                <div className={classes.typoDescription}>
                  {location?.state?.data?.Exam}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Grid container>
              <Grid item xs={5}>
                <div className={classes.typoTitle}>Type :</div>
              </Grid>
              <Grid item xs={7}>
                <div className={classes.typoDescription}>
                  {location?.state?.data?.allData?.Exam_Type__c}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div className="cardlsitbox">
        {/* <KenCard elevation={0} style={{ padding: 0 }}> */}
        <Box>
          <Box
            sx={{ borderBottom: 1, borderColor: 'divider' }}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 25px',
              background: '#FEFEFE',
              marginTop: 20,
            }}
            className={classes.card}
          >
            <Tabs
              style={{
                padding: '0 14px',
              }}
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Room Availablity"
                {...a11yProps(0)}
                style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'capitalize',
                }}
              />
              <Tab
                label="Seating Arrangement"
                {...a11yProps(1)}
                style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'capitalize',
                }}
              />
            </Tabs>
          </Box>
          <TabPanels
            value={value}
            index={0}
            style={{ marginTop: 20 }}
            className={classes.card}
          >
            <RoomAvailablity
              roomData={roomData}
              currentSeatingPlanData={currentSeatingPlanData}
              setEligible={setEligible}
              roomChoosen={roomChoosen}
              setRoomChoosen={setRoomChoosen}
              numStudents={numStudents}
              setNumStudents={setNumStudents}
              selectValueSpace={selectValueSpace}
              setSelectValueSpace={setSelectValueSpace}
              // selectOptionsSpace={selectOptionsSpace}
              facilityData={facilityData}
              handleRoomDeletion={handleRoomDeletion}
              handleRoomAddition={handleRoomAddition}
              eligibleStudentList={eligibleStudentList}
              edit={edit}
            />
          </TabPanels>

          <TabPanels value={value} index={1}>
            {roomChoosen && roomChoosen.length > 0 ? (
              <MainSeatingPlan
                facilityData={facilityData}
                roomChoosen={roomChoosen}
                roomDropdown={roomDropdown}
                numStudents={numStudents}
                currentSeatingPlanData={currentSeatingPlanData}
                interCandidateSpacing={selectValueSpace}
                eligibleStudentList={eligibleStudentList}
                setRoomChoosen={setRoomChoosen}
                examId={examId}
                array3D={array3D}
                setArray3D={setArray3D}
                edit={edit}
              ></MainSeatingPlan>
            ) : (
              <Paper>
                <Typography align="center">Rooms are Not selected!!</Typography>
              </Paper>
            )}
          </TabPanels>
        </Box>
        {/* </KenCard> */}
      </div>
    </Box>
  );
};

export default SeatingPlanArrangement;
